function initEmbosingTypes() {
  const item = document.querySelector('[data-embossing-types]');

  if (!item) return;

  item.dataset.count = item.children.length;
}

export {initEmbosingTypes};
